import { AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SmsAdv } from '@models/smsadv/smsadv';
import { SmsAdvCreateTabHandlerService, SmsAdvDirectionTab, SmsAdvErrorType } from '@services/sms-adv-create-tab-handler.service';
import { ActionSmsAdv, SmsAdvService } from '@services/smsadv.service';
import { ToastContainerDirective } from 'ngx-toastr';
import { Subscription } from 'rxjs';

export enum TabSmsAdv {
  TAB_SELECT_RECIPIENT = 1,
  TAB_CREATE_CAMPAIGN = 2,
  TAB_SUMMARY_CAMPAIGN = 3
}
@Component({
  selector: 'wsb-sms-adv-create',
  templateUrl: './sms-adv-create.component.html',
  styleUrls: ['./sms-adv-create.component.scss'],
  providers: [SmsAdvCreateTabHandlerService],
  standalone: false
})
export class SmsAdvCreateComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;
  @ViewChild('page') $page;
  @ViewChild('actionsBar') $actionsBar;

  currentTab = 0;
  summary = false;
  proceedBtnEnabled = true;
  sendBtnEnabled = false;
  hasPressedSaveDraftBtn = false;
  hasPressendSendBtn = true;

  tabSelectRecipientData;
  tabCreateCampaignData;
  tabSummary;

  smsAdvCampaignToSend: SmsAdv;
  smsAdvCampaignLastSaved: SmsAdv;

  subRoute: Subscription;
  subBack: Subscription;

  constructor(
    private tabHandlerService: SmsAdvCreateTabHandlerService,
    private smsAdvService: SmsAdvService,
    private elRef: ElementRef,

    private router: Router
  ) {}

  ngOnDestroy(): void {
    this.subRoute.unsubscribe();
    this.subBack.unsubscribe();
  }

  ngAfterViewChecked(): void {
    this.displayScrollIndicator();
  }

  scroll = (): void => {
    this.displayScrollIndicator();
  };

  ngOnInit(): void {
    this.checkAction();
    this.tabHandlerService.changeTab$.subscribe(tab => {
      if (tab) {
        this.currentTab = tab;
      }
    });
    this.handlerBackTab();
    this.handlerTabCompleted();
  }

  btnProceed() {
    this.hasPressedSaveDraftBtn = false;
    this.tabHandlerService.setCloseTab();
  }

  isEnableProceedBtn(value) {
    this.hasPressedSaveDraftBtn = false;
    this.proceedBtnEnabled = value;
  }

  btnSaveDraft() {
    this.hasPressedSaveDraftBtn = true;
    this.hasPressendSendBtn = false;
    this.tabHandlerService.setCloseTab();
  }

  isEnableSendBtn(value) {
    this.sendBtnEnabled = value;
  }

  backButton() {
    this.tabHandlerService.setBackTab();
  }

  btnSend() {
    this.hasPressedSaveDraftBtn = false;
    this.hasPressendSendBtn = true;
    this.tabHandlerService.setCloseTab();
  }

  // private method
  private checkAction() {
    this.subRoute = this.smsAdvService.actionSmsAdv$.subscribe(params => {
      if (params && params.data) {
        this.setDataFromAction(params.data);
        this.setCurrentTabFromAction(params.action);
      } else {
        this.currentTab = 1;
      }
    });
  }

  private setCurrentTabFromAction(action) {
    switch (action) {
      case ActionSmsAdv.ACTION_EDIT:
        this.currentTab = 1;
        break;
      case ActionSmsAdv.ACTION_COPY:
        this.tabHandlerService.setChangeTab(SmsAdvDirectionTab.JUMP_CREATE_CAMPAIGN);
        this.currentTab = 2;
        break;
      default:
        this.currentTab = 1;
    }
  }

  private setDataFromAction(data: SmsAdv) {
    if (data) {
      // new
      this.smsAdvCampaignToSend = data;
      // copy of new object
      this.smsAdvCampaignLastSaved = data;
    }
  }

  private handlerBackTab() {
    this.subBack = this.tabHandlerService.backTab$.subscribe(tab => {
      if (tab) {
        this.routeBackTab();
      }
    });
  }
  // action for changed tab
  private handlerTabCompleted() {
    this.tabHandlerService.tabCompleted$.subscribe(value => {
      switch (value) {
        case TabSmsAdv.TAB_SELECT_RECIPIENT:
          this.setFormDataFromTabSelectRecipient();
          this.smsAdvCampaignToSend = this.getFormDataFromTabSelRecipient();
          this.routeNextTab();
          break;
        case TabSmsAdv.TAB_CREATE_CAMPAIGN:
          this.retrieveFormDataByTabCreateCampaign();
          this.saveDraftSmsAdvData();

          break;
        case TabSmsAdv.TAB_SUMMARY_CAMPAIGN:
          if (this.hasPressedSaveDraftBtn) {
            this.routerToSmsADVCampaign();
          } else if (this.hasPressendSendBtn) {
            this.sendSmsAdvCampaign();
          }
          break;
      }
    });
  }
  private getFormDataByTabCreateCampaign() {
    if (this.smsAdvCampaignToSend) {
      // sms adv update
      if (this.smsAdvCampaignToSend.idSmsAdvCampaign > 0) {
        return { ...this.smsAdvCampaignToSend, ...this.tabCreateCampaignData };
      }
    }
    // sms adv doesn't create yet
    return { ...this.smsAdvCampaignToSend, ...this.tabCreateCampaignData };
  }

  private getFormDataFromTabSelRecipient() {
    if (this.smsAdvCampaignToSend) {
      // sms adv update
      if (this.smsAdvCampaignToSend.idSmsAdvCampaign > 0) {
        return { ...this.smsAdvCampaignToSend, ...this.tabSelectRecipientData };
      }
    }
    // sms adv doesn't create yet
    return { ...this.smsAdvCampaignToSend, ...this.tabSelectRecipientData };
  }

  private setFormDataFromTabSelectRecipient() {
    this.tabHandlerService.tabFormData$.subscribe(data => {
      this.tabSelectRecipientData = data;
    });
  }

  private retrieveFormDataByTabCreateCampaign() {
    this.tabHandlerService.tabFormData$.subscribe(data => {
      this.tabCreateCampaignData = data;
    });
  }

  private routeNextTab() {
    this.tabHandlerService.setChangeTab(SmsAdvDirectionTab.FORWARD);
  }

  private routeBackTab() {
    this.tabHandlerService.setChangeTab(SmsAdvDirectionTab.BACK);
  }

  private routerToSmsADVCampaign() {
    this.router.navigate(['//smsadv/campaigns']);
  }

  private saveDraftSmsAdvData() {
    const data = this.getFormDataByTabCreateCampaign();
    if (data && data.idSmsAdvCampaign === 0) {
      this.callApiCreateSmsAdvCampaign(data);
    } else if (data && data.idSmsAdvCampaign > 0) {
      const id = this.smsAdvCampaignToSend.idSmsAdvCampaign;
      this.callApiUpdateSmsAdvCampaign(id, this.smsAdvCampaignLastSaved, data);
    }
  }

  private sendSmsAdvCampaign() {
    const id = this.smsAdvCampaignToSend.idSmsAdvCampaign;
    this.smsAdvService.sendSmsAdvCampaign(id).subscribe(
      response => this.handlerResponseSendSmsAdv(),
      error => this.tabHandlerService.handlerErrorMsfg(SmsAdvErrorType.CREATE_ERROR, error, this.toastContainer)
    );
  }

  private handlerResponseSendSmsAdv() {
    this.tabHandlerService.handlerSuccessMsg();
    this.router.navigate(['/smsadv/campaigns']);
  }

  private callApiCreateSmsAdvCampaign(data) {
    this.smsAdvService.createSmsAdvCampaign(data).subscribe(
      response => this.handlerResponseSaveSmsAdv(response),
      error => this.tabHandlerService.handlerErrorMsfg(SmsAdvErrorType.CREATE_ERROR, error, this.toastContainer)
    );
  }

  private callApiUpdateSmsAdvCampaign(idSmsAdv, oldSmsAdv, newSmsAdv) {
    this.smsAdvService.updateSmsAdvCampaign(idSmsAdv, oldSmsAdv, newSmsAdv).subscribe(
      response => this.handlerResponseSaveSmsAdv(response),
      error => this.tabHandlerService.handlerErrorMsfg(SmsAdvErrorType.CREATE_ERROR, error, this.toastContainer)
    );
  }

  private handlerResponseSaveSmsAdv(response) {
    // new
    this.smsAdvCampaignToSend = response;
    // copy of new object
    this.smsAdvCampaignLastSaved = response;
    this.tabHandlerService.handlerSuccessMsg();
    if (!this.hasPressedSaveDraftBtn) {
      this.routeNextTab();
    } else {
      this.router.navigate(['/smsadv/campaigns']);
    }
  }

  private displayScrollIndicator() {
    if (!(this.$page && this.$actionsBar)) {
      return;
    }
    const $pageAccount: HTMLElement = this.$page.nativeElement;
    const $actionsBar: HTMLElement = this.$actionsBar.nativeElement;
    const $impersonateHeader: HTMLElement = document.getElementById('impersonate-header');

    if (!this.elRef.nativeElement || !this.elRef.nativeElement.closest('body')) {
      return;
    }

    const remainingHeight = window.innerHeight - $pageAccount.getBoundingClientRect().top;

    if (
      $pageAccount.clientHeight > remainingHeight + 5 &&
      $pageAccount.getBoundingClientRect().bottom - window.innerHeight - $impersonateHeader.getBoundingClientRect().bottom > 50
    ) {
      $actionsBar.classList.add('has--scroll-indicator');
    } else {
      $actionsBar.classList.remove('has--scroll-indicator');
    }
  }
}
